module.exports = __webpack_public_path__ + "static/media/u21a-c_a5a.ccf6b86e.mp3";